import React from "react";
import { useTranslation } from "react-i18next";
import { Line } from "@nivo/line";

const lineProperties = {
  width: 750,
  height: 400,
  margin: { top: 40, right: 120, bottom: 40, left: 100 }
};

const HoursInternational = ({ data }) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  return (
    <div className="page">
    <div className="h-10" />
    <div className="w-full h-px bg-gray-800" />
    <div className="p-5 h-16">
        <div className="text-international mb-2 font-bold">{t("uniques_hour")}</div>
    </div>
      <div className="w-full p-5 mb-10">
        <Line
          {...lineProperties}
          colors={{ scheme: "dark2" }}
          curve="monotoneX"
          data={[
            {
              id: "International Max.",
              data: Object.keys(data.perHour.international).map((d) => {
                return {
                  x: d,
                  y: data.perHour.international[d].max
                };
              })
            },
            {
              id: "International Min.",
              data: Object.keys(data.perHour.international).map((d) => {
                return {
                  x: d,
                  y: data.perHour.international[d].min
                };
              })
            },
            {
              id: "International Avg.",
              data: Object.keys(data.perHour.international).map((d) => {
                return {
                  x: d,
                  y: data.perHour.international[d].total
                };
              })
            }
          ]}
          xScale={{
            type: "linear",
            min: 0,
            max: 23
          }}
          axisBottom={{
            tickValues: 24,
            format: (d) => `${d}:00`,
            tickRotation: -75
          }}
          legends={[
            {
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 100,
              translateY: 0,
              itemsSpacing: 0,
              itemDirection: "left-to-right",
              itemWidth: 80,
              itemHeight: 20,
              itemOpacity: 0.75,
              symbolSize: 12,
              symbolShape: "circle",
              symbolBorderColor: "rgba(0, 0, 0, .5)",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemBackground: "rgba(0, 0, 0, .03)",
                    itemOpacity: 1
                  }
                }
              ]
            }
          ]}
        />
      </div>
    </div>
  );
};

export default HoursInternational;
